module.exports = __webpack_public_path__ + "static/img/6.0b5b4a7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/global_assets/images/carriers/6.png
// module id = 2dg4
// module chunks = 150